import React, {Component} from 'react';
import {observer} from "mobx-react";
import {toJS} from "mobx";
import {checkbox, custom, input} from "../../../utils/linker";
import ImageDrop from "../../Helpers/ImageDrop";

class Image extends Component {
  componentDidMount() {
    if(!this.props.linker.value.image) {
      this.props.linker.value.image = null;
    }

  }
  deleteMe(deleteState) {
    console.log('deleteStateChanged', deleteState);
    if(deleteState) {
      this.props.linker.value.delete=1;
    } else {
      delete this.props.linker.value.delete;
    }
    console.log('deleteStateChanged',toJS(this.props.linker.value));
  }
  render() {
    return (
      <div className="padd20 bg-w2 pr rad4 mbottom10">
        <div className="pa pa-tr mdi mdi-close sc1 fs24 lh10 pointer" onClick={()=>{ this.props.deleteMe(); }}></div>
        <ImageDrop aspect="900x80" {...custom(this.props.linker,'value')} onDeleteChange={(deleteState)=>{  this.deleteMe(deleteState); }} />
        <div className="ptop5">
          <label>
            <input type="checkbox" value="1" {...checkbox(this.props.linker.value,"spoiler")} /><span className="vam"></span> <span className="dib vam">Есть спойлеры</span>
          </label>
        </div>
      </div>
    )
  }
}

export default observer(Image);